import { useQuery } from '@tanstack/react-query';
import { getAccountsInfo } from '../requests';
import { useSessionStore } from '@/entities/session';
import { CACHE_TIME_5_MINUTES } from '@/shared/config';
import { accountsKeys } from '../keys';

const useAccountsInfo = () => {
  const { session } = useSessionStore();

  const { data, isLoading, error, isError } = useQuery({
    queryKey: [accountsKeys.info, session?.userId],
    queryFn: getAccountsInfo,
    enabled: !!session?.userId,
    staleTime: ({ state: { data } }) =>
      data?.restsCacheLifeTime || CACHE_TIME_5_MINUTES,
  });

  return {
    accountsInfo: data,
    isAccountsInfoLoading: isLoading,
    accountsInfoError: error,
    isAccountInfoError: isError,
  };
};

export { useAccountsInfo };
